import { z } from 'zod';

export const leadGenerationFormSchema = z
  .object({
    fullName: z
      .string()
      .min(1, 'Full name is required')
      .max(100, 'Full name must not exceed 100 characters'),
    phone: z
      .string()
      .min(1, 'Phone number is required')
      .regex(/^(?:[+]?\d+(?:\s*\d+)*(?:-\d+)?)?$/, 'Invalid phone number'),
    email: z
      .string()
      .min(1, 'Email is required')
      .email('Invalid email address'),
    establishmentAddress: z
      .string()
      .min(1, 'Establishment address is required'),
    establishmentName: z
      .string()
      .min(1, 'Establishment name is required')
      .max(250, 'Establishment name must not exceed 250 characters'),
    notes: z.string().optional(),
    marketingSignup: z.boolean().default(false),
    webFMSChoice: z.string().optional(),
    otherWebFMSSystem: z.string().optional(),
    isWebFmsForm: z.boolean().default(false),
  })
  .refine(
    (data) => {
      if (data.isWebFmsForm) {
        return data.webFMSChoice && data.webFMSChoice.trim().length > 0;
      }
      return true;
    },
    {
      message: 'Please specify your Web FMS system',
      path: ['webFMSChoice'],
    },
  )
  .refine(
    (data) => {
      if (data.webFMSChoice?.trim().toLowerCase() === 'other') {
        return (
          data.otherWebFMSSystem && data.otherWebFMSSystem.trim().length > 0
        );
      }
      return true;
    },
    {
      message: 'Please specify your Web FMS system',
      path: ['otherWebFMSSystem'],
    },
  );

export type LeadGenerationFormSchema = z.infer<typeof leadGenerationFormSchema>;
